import { Locale } from '../types';

export const LOCALES: Locale[] = ['ru', 'en', 'kz', 'am', 'ge'];

export const LOCALES_FOR_CACHE = LOCALES.map((locale) => ({ locale }));

export const DEFAULT_LOCALE = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

export const SCREEN_SM = 640;
export const SCREEN_MD = 768;
export const SCREEN_LG = 1024;
export const SCREEN_XL = 1280;
export const SCREEN_XXL = 1536;
